
import { createEntityAdapter, createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AnimalInfo, FeedCurve } from "../..";
import { isEqual } from "lodash";

// WARNING make sure we are talking about the same store there will for a be two stores

export const feedCurveDataAdapter = createEntityAdapter({
  selectId: (feedCurve: FeedCurve) => feedCurve.feedCurveId
});


export const feedCurvesSlice = createSlice({
  name: "feedCurve",
  initialState: feedCurveDataAdapter.getInitialState({loading: "idle"}),
  reducers: {
    addFeedCurve: (state, {payload}: PayloadAction<FeedCurve[]>) => {
      state.loading = "false";
      feedCurveDataAdapter.addMany(state, payload);
    },
    updateFeedCurve: feedCurveDataAdapter.updateOne,
    updateManyFeedCurves: feedCurveDataAdapter.updateMany,
    upsertFeedCurves: (state, { payload }: PayloadAction<FeedCurve[]>) => {
      const existing = feedCurveDataAdapter.getSelectors().selectAll(state);
      if (existing.length !== payload.length || !isEqual(existing, payload)) {
        feedCurveDataAdapter.upsertMany(state, payload);
      }
    },
    clearFeedCurves: feedCurveDataAdapter.removeAll,
  },
})


export const { addFeedCurve, updateFeedCurve, updateManyFeedCurves, clearFeedCurves, upsertFeedCurves} = feedCurvesSlice.actions;
export const {selectById: selectFeedCurveById, selectAll: SelectAllFeedCurves} = feedCurveDataAdapter.getSelectors();